/* hod-ms-builder.js — H.2 mini split builder (8/23).
   Design: HOD Mini Split Builder (Claude Design import). Data:
   - window.HOD_MS_RAW: live component rows (hod-ms-catalog.liquid) —
     prices/compare in CENTS, live variant ids + inventory.
   - window.HOD_PP_RAW: CPS plan catalog; CMEQ 2yr/5yr band ladders.
   - window.hodResolveStock: PDP-parity stock labels (G.4).
   - money flows: discount code + quote via the staging hod-custom-app,
     same contracts as hod-bundle-builder.js.
   Classification is by SKU pattern; unknown SKUs are ignored, so Stas
   can curate the hod-ms-* collections without breaking the page. */
(function () {
  var root = document.getElementById('hodms');
  if (!root) return;

  var CUSTOM_APP = 'https://hod-custom-app-v2-591bfca71074.herokuapp.com'; /* v2 (renamed from staging 8/24) quote.php: GraphQL invoice send + zip->tax; old prod app's invoice call is silently broken */
  var DISC_CART = parseFloat(root.getAttribute('data-ms-discount-cart')) || 0;
  var DISC_QUOTE = parseFloat(root.getAttribute('data-ms-discount-quote')) || 0;
  var MAX_ZONES = parseInt(root.getAttribute('data-ms-maxzones'), 10) || 6;

  var ACC_NOTES = {};
  (root.getAttribute('data-ms-accnotes') || '').split('\n').forEach(function (line) {
    var i = line.indexOf(':');
    if (i > 0) ACC_NOTES[line.slice(0, i).trim().toUpperCase()] = line.slice(i + 1).trim();
  });

  function money(cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function stockFor(row) {
    var r = window.hodResolveStock
      ? window.hodResolveStock(row.vnd, { availableForSale: !!row.av, quantityAvailable: typeof row.q === 'number' ? row.q : null })
      : ['', '', 'in'];
    return { label: r[0] || '', text: r[1] || '', state: r[2] || 'in' };
  }

  /* ---------- catalog classification (by SKU) ---------- */
  var RAW = window.HOD_MS_RAW || { cond: [], hand: [], sys1: [], ls: [], acc: [] };
  /* Per-condenser rules from the MRCOOL manuals (doxrepo install manuals +
     support KB, verified 8/23): ft = max TOTAL line set; head = largest
     single air handler the condenser accepts; conn = max connected BTU (K).
     Olympus conn = the official match-up chart (125-133%); DIY 5th gen has
     no published chart, so conn = the 4th-gen chart maxima (117-122%) with
     the 55K set to 66 to match combos HOD already sells. */
  function condRules(install, ports, cap) {
    if (install === 'diy') {
      if (ports === 3) return { ft: 172, head: 12, conn: 21 };
      if (ports === 4) return { ft: 221, head: 18, conn: 33 };
      if (ports === 5) return { ft: 221, head: 24, conn: 42 };
      return { ft: 221, head: 36, conn: cap >= 55 ? 66 : 54 };
    }
    if (ports === 3) return { ft: 197, head: 12, conn: 24 };
    if (ports === 4) return { ft: 262, head: 24, conn: 36 };
    if (ports === 5) return { ft: 262, head: 24, conn: 48 };
    return { ft: 262, head: 24, conn: 60 };
  }

  var conds = [], hands = [], sys1 = [], linesets = [], accs = [];
  (RAW.cond || []).forEach(function (r) {
    var m;
    if ((m = /^DIY-MULTI(\d)-(\d+)HP/.exec(r.sku))) conds.push(Object.assign({ install: 'diy', multi: true, ports: +m[1], cap: +m[2] }, condRules('diy', +m[1], +m[2]), r));
    else if ((m = /^MULTI(\d)-(\d+)HP/.exec(r.sku))) conds.push(Object.assign({ install: 'pro', multi: true, ports: +m[1], cap: +m[2] }, condRules('pro', +m[1], +m[2]), r));
    else if ((m = /^O-ES-(\d+)-HP-C/.exec(r.sku))) conds.push(Object.assign({ install: 'pro', multi: false, ports: 1, cap: +m[1] }, r));
  });
  (RAW.hand || []).forEach(function (r) {
    var m;
    if ((m = /^DIYCASSETTE(\d+)HP/.exec(r.sku))) hands.push(Object.assign({ install: 'diy', type: 'ceiling', btu: +m[1] }, r));
    else if ((m = /^DIY-(\d+)-HP-WMAH/.exec(r.sku))) hands.push(Object.assign({ install: 'diy', type: 'wall', btu: +m[1] }, r));
    else if ((m = /^CASSETTE(\d+)HP/.exec(r.sku))) hands.push(Object.assign({ install: 'pro', type: 'ceiling', btu: +m[1] }, r));
    else if ((m = /^DUCT-(\d+)HP/.exec(r.sku))) hands.push(Object.assign({ install: 'pro', type: 'duct', btu: +m[1] }, r));
    else if ((m = /^O-(\d+)-HP-WMAH/.exec(r.sku))) hands.push(Object.assign({ install: 'pro', type: 'wall', btu: +m[1] }, r));
  });
  (RAW.sys1 || []).forEach(function (r) {
    var m;
    if ((m = /^DIY-(\d+)-HP-WM-/.exec(r.sku))) sys1.push(Object.assign({ type: 'wall', btu: +m[1] }, r));
    else if ((m = /^DIY-(\d+)-HP-CM-/.exec(r.sku))) sys1.push(Object.assign({ type: 'ceiling', btu: +m[1] }, r));
  });
  (RAW.ls || []).forEach(function (r) {
    var m;
    if ((m = /^DIY(\d+)-(1438|1412|3858)(C?)-O$/.exec(r.sku))) linesets.push(Object.assign({ install: 'diy', len: +m[1], gauge: m[2], cable: m[3] === 'C' }, r));
    else if ((m = /^MC(\d+)-(1438|1412|3858)/.exec(r.sku))) linesets.push(Object.assign({ install: 'pro', len: +m[1], gauge: m[2], cable: false }, r));
  });
  (RAW.acc || []).forEach(function (r) { accs.push(r); });

  var PP = window.HOD_PP_RAW || [];
  function cmeqLadder(years) {
    return PP.filter(function (e) { return e.f === 'CMEQ' && e.y === years; })
      .sort(function (a, b) { return a.total - b.total; });
  }
  var WARR_LADDERS = { 2: cmeqLadder(2), 5: cmeqLadder(5) };
  function warrFor(years, itemCents) {
    var lad = WARR_LADDERS[years] || [];
    if (!lad.length) return null;
    for (var i = 0; i < lad.length; i++) { if (itemCents < lad[i].total) return lad[i]; }
    return lad[lad.length - 1];
  }

  function gaugeFor(install, btu) { return btu <= 12 ? '1438' : btu === 18 ? '1412' : '3858'; }
  function lsFor(install, btu, len) {
    var g = gaugeFor(install, btu);
    var cands = linesets.filter(function (l) { return l.install === install && l.gauge === g && l.len === len; });
    cands.sort(function (a, b) { return ((b.av ? 1 : 0) - (a.av ? 1 : 0)) || ((a.cable ? 1 : 0) - (b.cable ? 1 : 0)); });
    return cands[0] || null;
  }
  function lsLengths(install) { return install === 'pro' ? [16, 25, 50] : [16, 25, 35, 50, 66, 75]; }
  function btuOptions(install, type, oneZone) {
    if (install === 'pro') return [9, 12, 18, 24];
    if (oneZone) return type === 'ceiling' ? [18] : [9, 12, 18, 24, 36];
    return type === 'ceiling' ? [6, 9, 12, 18] : [6, 9, 12, 18, 24, 36];
  }
  var ALL_BTUS = [6, 9, 12, 18, 24, 36];
  var SQFT = { 6: '200', 9: '375', 12: '500', 18: '750', 24: '1,000', 36: '1,500' };
  var TYPE_LABEL = { wall: 'Wall Mount', ceiling: 'Ceiling Cassette', duct: 'Ducted' };
  var TYPE_SHORT = { wall: 'WALL', ceiling: 'CEILING', duct: 'DUCTED' };

  /* ---------- state ---------- */
  var S = {
    install: null, /* Stas H.2 r2: nothing preselected — step 1 shows the amber start-here badge */
    zones: [{ type: 'wall', btu: 0, ls: 0 }, { type: 'wall', btu: 0, ls: 0 }],
    acc: {}, warr: null, /* null = unpicked, 0 = no plan, 2, 5 */
    err: null, adding: false,
    sizeTab: 'hand', sizeHov: 2
  };

  function seriesName() { return S.install === 'diy' ? 'MRCOOL DIY 5th Gen' : 'MRCOOL Olympus'; }
  function oneZone() { return S.zones.length === 1; }
  function diyOne() { return oneZone() && S.install === 'diy'; }
  function zoneDone(z) { return !!(z.type && z.btu && (z.ls || diyOne())); }
  function allBtu() { return S.zones.every(function (z) { return !!z.btu; }); }
  function allDone() { return S.zones.every(zoneDone); }
  function totalK() { return S.zones.reduce(function (a, z) { return a + (z.btu || 0); }, 0); }

  /* ---------- resolution ---------- */
  function condLadderCaps() {
    var seen = {}, out = [];
    conds.filter(function (c) { return c.install === S.install && c.multi; })
      .sort(function (a, b) { return a.cap - b.cap; })
      .forEach(function (c) { if (!seen[c.cap]) { seen[c.cap] = 1; out.push(c.cap); } });
    return out.length ? out : [18, 27, 36, 48, 55];
  }
  function resolve() {
    var R = { mode: 'parts', sys: null, cond: null, zones: [], over: false };
    if (diyOne()) {
      var z = S.zones[0];
      R.mode = 'sys1';
      R.sys = z.btu ? sys1.filter(function (s) { return s.type === z.type && s.btu === z.btu; }).sort(function (a, b) { return b.av - a.av; })[0] || null : null;
      R.zones = [{ z: z, hand: null, ls: null }];
      return R;
    }
    if (oneZone()) {
      var z1 = S.zones[0];
      R.cond = z1.btu ? conds.filter(function (c) { return c.install === 'pro' && !c.multi && c.cap === z1.btu; })
        .sort(function (a, b) { return (b.av ? 1 : 0) - (a.av ? 1 : 0); })[0] || null : null;
    } else {
      var tk = totalK();
      var cands = conds.filter(function (c) { return c.install === S.install && c.multi && c.ports >= S.zones.length; })
        .sort(function (a, b) { return (a.cap - b.cap) || ((b.av ? 1 : 0) - (a.av ? 1 : 0)); });
      if (allBtu() && tk > 0) {
        R.cond = null;
        var maxB = Math.max.apply(null, S.zones.map(function (z) { return z.btu || 0; }));
        for (var i = 0; i < cands.length; i++) {
          if (tk <= cands[i].conn && maxB <= cands[i].head) { R.cond = cands[i]; break; }
        }
        R.over = !R.cond;
      }
    }
    R.zones = S.zones.map(function (z) {
      return {
        z: z,
        hand: z.btu ? hands.filter(function (h) { return h.install === S.install && h.type === z.type && h.btu === z.btu; }).sort(function (a, b) { return b.av - a.av; })[0] || null : null,
        ls: (z.btu && z.ls) ? lsFor(S.install, z.btu, z.ls) : null
      };
    });
    return R;
  }
  function pickRows(R) { /* resolved product rows going into the cart (excl. warranty + acc) */
    var rows = [];
    if (R.mode === 'sys1') { if (R.sys) rows.push({ row: R.sys, room: 'Room 1' }); return rows; }
    if (R.cond) rows.push({ row: R.cond, room: '' });
    R.zones.forEach(function (rz, i) {
      if (rz.hand) rows.push({ row: rz.hand, room: 'Room ' + (i + 1) });
      if (rz.ls) rows.push({ row: rz.ls, room: 'Room ' + (i + 1) });
    });
    return rows;
  }
  function totals() {
    var R = resolve();
    var rows = pickRows(R);
    var itemsSum = 0, compareSum = 0;
    rows.forEach(function (p) { itemsSum += p.row.p; compareSum += Math.max(p.row.c || 0, p.row.p); });
    var accSum = 0, accCompare = 0, accCount = 0;
    accs.forEach(function (a) { var q = S.acc[a.vid] || 0; if (q > 0) { accSum += a.p * q; accCompare += Math.max(a.c || 0, a.p) * q; accCount++; } });
    itemsSum += accSum; compareSum += accCompare;
    var pct = DISC_CART;
    var discounted = Math.round(itemsSum * (100 - pct) / 100);
    var discountAmt = itemsSum - discounted;
    var hasPrice = R.mode === 'sys1' ? !!R.sys
      : (!!R.cond && allBtu() && R.zones.every(function (rz) { return !!rz.hand; }));
    var wPick = (hasPrice && (S.warr === 2 || S.warr === 5)) ? warrFor(S.warr, discounted) : null;
    var warrCents = wPick ? wPick.price : 0;
    var ftTotal = 0;
    S.zones.forEach(function (z) { if (z.ls) { ftTotal += z.ls; } });
    var lsCount = rows.filter(function (p) { return !!p.row.len; }).length;
    if (diyOne()) { lsCount = 1; }
    return {
      R: R, rows: rows, itemsSum: itemsSum, compareSum: compareSum, accSum: accSum, accCount: accCount,
      pct: pct, discounted: discounted, discountAmt: discountAmt,
      wPick: wPick, warrCents: warrCents,
      total: discounted + warrCents, listTotal: compareSum + warrCents,
      lsCount: lsCount, ftTotal: ftTotal,
      capFt: (R.cond && R.cond.multi) ? R.cond.ft : 0,
      hasPrice: hasPrice
    };
  }

  /* ---------- placeholder art ---------- */
  var PH = {
    cond: '<svg width="130" height="150" viewBox="0 0 130 150"><rect x="1" y="1" width="128" height="148" rx="6" fill="#E9F2F9" stroke="#C2D9EA" stroke-width="2"/><circle cx="65" cy="62" r="38" fill="none" stroke="#fff" stroke-width="5"/><circle cx="65" cy="62" r="7" fill="#fff"/><line x1="12" y1="116" x2="118" y2="116" stroke="#fff" stroke-width="4"/><line x1="12" y1="128" x2="118" y2="128" stroke="#fff" stroke-width="4"/></svg>',
    wall: '<svg width="118" height="64" viewBox="0 0 118 64"><rect x="1" y="1" width="116" height="54" rx="10" fill="#E9F2F9" stroke="#C2D9EA" stroke-width="2"/><line x1="12" y1="42" x2="106" y2="42" stroke="#fff" stroke-width="5"/><rect x="12" y="12" width="52" height="7" rx="3" fill="#fff"/></svg>',
    ceiling: '<svg width="96" height="72" viewBox="0 0 96 72"><rect x="1" y="1" width="94" height="70" rx="5" fill="#E9F2F9" stroke="#C2D9EA" stroke-width="2"/><rect x="14" y="14" width="68" height="44" rx="3" fill="none" stroke="#fff" stroke-width="4"/><line x1="22" y1="36" x2="74" y2="36" stroke="#fff" stroke-width="4"/></svg>',
    duct: '<svg width="120" height="50" viewBox="0 0 120 50"><rect x="1" y="1" width="118" height="40" rx="5" fill="#E9F2F9" stroke="#C2D9EA" stroke-width="2"/><line x1="10" y1="13" x2="110" y2="13" stroke="#fff" stroke-width="4"/><line x1="10" y1="22" x2="110" y2="22" stroke="#fff" stroke-width="4"/><line x1="10" y1="31" x2="110" y2="31" stroke="#fff" stroke-width="4"/></svg>'
  };
  var ART = window.HOD_MS_ART || { cond: {}, diy: {}, pro: {} };
  function artHandler(install, type) { return (ART[install] || {})[type] || null; }
  function artCond(ports) { return ART.cond[String(ports)] || ART.cond['2'] || null; }
  var CHECK = '<svg width="9" height="9" viewBox="0 0 12 12"><path d="M2 6.5L4.7 9L10 3.5" fill="none" stroke="#fff" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ---------- renders ---------- */
  function stocklineHtml(row) {
    var st = stockFor(row);
    if (!st.label) return '';
    return '<span class="hodms__stockline hodms__stockline--' + esc(st.state) + '"><i></i><b>' + esc(st.label) + '</b>' +
      (st.text ? '<span class="hodms__stocktext">&middot; ' + esc(st.text) + '</span>' : '') + '</span>';
  }
  function renderInstall() {
    root.querySelectorAll('[data-ms-install]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-ms-install') === S.install);
    });
    root.querySelector('[data-ms-probanner]').hidden = S.install !== 'pro';
    root.querySelector('[data-ms-installname]').textContent = S.install === 'diy' ? 'DIY' : S.install === 'pro' ? 'Professional' : '—';
    root.querySelector('[data-ms-installword]').textContent = S.install === 'pro' ? 'professional' : 'DIY';
    var b1 = root.querySelector('[data-ms-step1badge]');
    b1.classList.toggle('is-todo', !S.install);
    b1.innerHTML = S.install ? CHECK : '1';
    /* everything below step 1 stays locked until the install type is chosen */
    root.querySelectorAll('[data-ms-step="2"],[data-ms-step="3"],[data-ms-step="4"]').forEach(function (c) {
      c.classList.toggle('is-locked', !S.install);
    });
    root.querySelector('[data-ms-band]').classList.toggle('is-locked', !S.install);
    root.querySelector('.hodms__summary').classList.toggle('is-locked', !S.install);
  }
  function renderZones(t) {
    var host = root.querySelector('[data-ms-zones]');
    var html = S.zones.map(function (z, i) {
      var done = zoneDone(z);
      if (done && !z.open) {
        /* completed zones auto-minimize into a summary row (Stas r4) */
        var lsTxt = diyOne() ? '25 ft (included)' : z.ls + ' ft line set';
        return '<div class="hodms__zone is-done hodms__zone--compact" data-ms-zopen="' + i + '" role="button" tabindex="0">' +
          '<div class="hodms__zone-head">' +
            '<span class="hodms__zone-badge">' + CHECK + '</span>' +
            '<span class="hodms__zone-name">Zone / Room ' + (i + 1) + '</span>' +
            '<span class="hodms__zone-sum">' + TYPE_LABEL[z.type] + ' &middot; ' + z.btu + 'K &middot; ' + lsTxt + '</span>' +
            '<button type="button" class="hodms__zone-caret" data-ms-zopen="' + i + '" aria-label="Edit zone"><svg width="12" height="12" viewBox="0 0 12 12"><path d="M2 4.5l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
            (S.zones.length > 1 ? '<button type="button" class="hodms__zone-remove" data-ms-zremove="' + i + '" aria-label="Remove zone">&#10005;</button>' : '') +
          '</div></div>';
      }
      var opts = btuOptions(S.install, z.type, oneZone());
      var types = S.install === 'pro' ? ['wall', 'ceiling', 'duct'] : ['wall', 'ceiling'];
      var typeChips = types.map(function (tp) {
        return '<button type="button" class="hodms__chip' + (z.type === tp ? ' is-on' : '') + '" data-ms-ztype="' + i + '|' + tp + '">' + TYPE_LABEL[tp] + '</button>';
      }).join('');
      var btuChips = ALL_BTUS.map(function (b) {
        var ok = opts.indexOf(b) > -1;
        if (ok) {
          ok = diyOne()
            ? sys1.some(function (s) { return s.type === z.type && s.btu === b; })
            : hands.some(function (h) { return h.install === S.install && h.type === z.type && h.btu === b; });
        }
        return '<button type="button" class="hodms__chip' + (z.btu === b ? ' is-on' : '') + '" data-ms-zbtu="' + i + '|' + b + '"' +
          (ok ? '' : ' disabled title="' + (S.install === 'pro' ? 'Not available in the professional line' : oneZone() ? 'Not available as a single-zone system' : 'Not available with this air handler type') + '"') + '>' + b + 'K</button>';
      }).join('');
      var lsField;
      if (diyOne()) {
        lsField = '<select class="hodms__select is-locked" aria-label="Line set length" disabled><option>25 Ft. &mdash; Included with Single-Zone system</option></select>';
      } else {
        var lens = lsLengths(S.install);
        lsField = '<select class="hodms__select' + (z.ls ? ' is-set' : '') + '" aria-label="Line set length" data-ms-zls="' + i + '">' +
          '<option value="">Please Select</option>' +
          lens.map(function (L) {
            var p = z.btu ? lsFor(S.install, z.btu, L) : null;
            var dead = z.btu && !p;
            return '<option value="' + L + '"' + (z.ls === L ? ' selected' : '') + (dead ? ' disabled' : '') + '>' + L + ' Ft.' + (p ? ' &mdash; ' + money(p.p) : dead ? ' &mdash; unavailable' : '') + '</option>';
          }).join('') + '</select>';
      }
      return '<div class="hodms__zone' + (done ? ' is-done' : '') + '">' +
        '<div class="hodms__zone-head">' +
          '<span class="hodms__zone-badge">' + (done ? CHECK : '!') + '</span>' +
          '<span class="hodms__zone-name">Zone / Room ' + (i + 1) + '</span>' +
          (done ? '<button type="button" class="hodms__zone-caret" data-ms-zclose="' + i + '" aria-label="Minimize zone"><svg width="12" height="12" viewBox="0 0 12 12"><path d="M2 7.5l4-4 4 4" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' : '') +
          (S.zones.length > 1 ? '<button type="button" class="hodms__zone-remove" data-ms-zremove="' + i + '" aria-label="Remove zone">&#10005;</button>' : '') +
        '</div>' +
        '<div class="hodms__zone-field"><div class="hodms__zone-label"><span>Air Handler Type</span>' + (i === 0 ? '<button type="button" class="hodms__helpbtn" data-ms-help="type" aria-label="Help">?</button>' : '') + '</div>' +
          '<div class="hodms__chiprow">' + typeChips + '</div></div>' +
        '<div class="hodms__zone-field"><div class="hodms__zone-label"><span>BTU Size</span>' + (i === 0 ? '<button type="button" class="hodms__helpbtn" data-ms-help="btu" aria-label="Help">?</button>' : '') +
          (z.btu ? '<span class="hodms__zone-hint">&middot; up to ' + SQFT[z.btu] + ' sq ft</span>' : '') + '</div>' +
          '<div class="hodms__chiprow">' + btuChips + '</div></div>' +
        '<div class="hodms__zone-field"><div class="hodms__zone-label"><span>Line Set Length</span>' + (i === 0 ? '<button type="button" class="hodms__helpbtn" data-ms-help="ls" aria-label="Help">?</button>' : '') + '</div>' +
          lsField + '</div>' +
      '</div>';
    }).join('');
    host.innerHTML = html;
    var doneCount = S.zones.filter(zoneDone).length;
    root.querySelector('[data-ms-zonesdone]').textContent = doneCount + ' of ' + S.zones.length + ' configured';
    var b2 = root.querySelector('[data-ms-step2badge]');
    b2.innerHTML = allDone() ? CHECK : '2';
    var warn = root.querySelector('[data-ms-ftwarn]');
    if (t.capFt && t.ftTotal > t.capFt) {
      warn.hidden = false;
      warn.innerHTML = '<span class="hodms__warnbang">!</span><span>' + t.ftTotal + ' ft of line set &mdash; this system maxes out at <b>' + t.capFt + ' ft total</b>. Shorten a run or drop a zone.</span>';
    } else warn.hidden = true;
    var add = root.querySelector('[data-ms-addzone]');
    add.disabled = S.zones.length >= MAX_ZONES;
  }
  function renderBand(t) {
    var R = t.R;
    var band = root.querySelector('[data-ms-band]');
    band.classList.toggle('is-over', !!R.over);
    var matched = t.hasPrice;
    var name = '', detail = '', imgRow = R.mode === 'sys1' ? R.sys : R.cond;
    if (R.over) {
      band.innerHTML = '<div class="hodms__band-body"><span class="hodms__band-eyebrow">CONDENSER &mdash; OVER CAPACITY</span>' +
        '<span class="hodms__band-detail">' + (totalK() * 1000).toLocaleString('en-US') + ' BTU of handlers is more than the largest ' + (S.install === 'diy' ? 'DIY' : 'Olympus') + ' condenser supports. Drop one or more zones to a smaller BTU size, split the rooms into two systems (build and add each to cart separately), or call us and we&rsquo;ll spec it: <b>800-495-0144</b>.</span></div>';
      return;
    }
    if (matched) {
      var caps = condLadderCaps();
      var ratio = R.mode === 'sys1' ? 100 : Math.round(totalK() / R.cond.cap * 100);
      if (R.mode === 'sys1') {
        name = R.sys.t.replace(/\s*\([^)]*\)\s*$/, '');
        detail = 'Complete single-zone system &mdash; condenser, ' + TYPE_LABEL[S.zones[0].type].toLowerCase() + ' handler &amp; 25 ft line set included';
      } else {
        name = seriesName() + ' \u2014 ' + (oneZone() ? 'Single-Zone' : S.zones.length + '-Zone') + ' Condenser';
        detail = R.cond.cap + ',000 BTU &middot; ' + (R.cond.multi ? R.cond.ports + ' ports &middot; ' : '') + 'sized for your ' + totalK() + 'K of handlers (' + ratio + '% connected)';
      }
      var bandImg = artCond((R.cond && R.cond.multi) ? R.cond.ports : 2) || (imgRow && imgRow.img) || null;
      band.innerHTML =
        '<span class="hodms__band-img" role="img" aria-label="Condenser"' + (bandImg ? ' style="background-image:url(&quot;' + esc(bandImg) + '&quot;)"' : '') + '></span>' +
        '<div class="hodms__band-body"><span class="hodms__band-eyebrow">CONDENSER &mdash; MATCHED AUTOMATICALLY</span>' +
        '<span class="hodms__band-name">' + esc(name) + '</span>' +
        '<span class="hodms__band-detail">' + detail + ' &middot; <a data-ms-sizing-open role="button" tabindex="0">How sizing works</a></span>' +
        stocklineHtml(imgRow) + '</div>' +
        '<span class="hodms__band-check">' + CHECK + '</span>';
    } else {
      band.innerHTML = '<div class="hodms__band-body"><span class="hodms__band-eyebrow">CONDENSER &mdash; MATCHED AUTOMATICALLY</span>' +
        '<span class="hodms__band-detail">Size every zone above and we&rsquo;ll match the right condenser &mdash; correct BTU capacity' + (oneZone() ? '' : ' and port count') + ', no guesswork. <a data-ms-sizing-open role="button" tabindex="0">How sizing works</a></span></div>';
    }
  }
  /* accessories are a STRICT, logic-driven list (Stas H.2 r3): the correct
     condenser wall kit by matched size (MB176 ≤18K, MB440A 24-36K, none for
     48/55 — pad only), the CoolGuard pad as its alternative (mutually
     exclusive), LineGuard with color + quantity, the H600-B riser, then the
     DiversiTech electrical hookup rows. MRCOOL + DiversiTech only. */
  var ACC_MOUNT_SKUS = ['MB176', 'MB440A'];
  var ACC_LG_COLORS = [['MLG450', 'White'], ['MLG450-T-01', 'Tan'], ['MLG450-G-01', 'Gray']];
  var ACC_ELEC = ['DDS-60U', '6-34-6', '6-34-6NM', '6-12-6', '6-12-6NM'];
  function accBySku(sku) {
    return accs.filter(function (a) { return (a.sku || '').toUpperCase() === sku.toUpperCase(); })[0] || null;
  }
  function accRowHtml(a, extraNote, ctl, noDim) {
    var q = S.acc[a.vid] || 0, on = q > 0;
    var note = extraNote != null ? extraNote : (ACC_NOTES[(a.sku || '').toUpperCase()] || '');
    var oos = a.av === false;
    var st = stockFor(a);
    var qv = ' class="bundle-builder--choose-view" data-product-url="/products/' + esc(a.h) + '" data-stock="' + esc(st.label) + '" data-delivery="' + esc(st.text) + '"';
    var stl = '';
    if (st.label) stl = '<span class="hodms__stockline hodms__stockline--' + esc(st.state) + '"><i></i><b>' + esc(st.label) + '</b></span>';
    return '<div class="hodms__acc' + (on ? ' is-on' : '') + (oos && !noDim ? ' is-oos' : '') + '" data-ms-acc="' + esc(a.vid) + '" tabindex="0">' +
      '<span class="hodms__acc-box">' + (on ? CHECK : '') + '</span>' +
      '<span class="hodms__acc-img" role="img" aria-label="' + esc(a.t) + '"' + (a.img ? ' style="background-image:url(&quot;' + esc(a.img) + '&quot;)"' : '') + '></span>' +
      '<span class="hodms__acc-body"><span class="hodms__acc-name">' + esc(a.t) + '</span>' +
      stl +
      (note ? '<span class="hodms__acc-note">' + esc(note) + '</span>' : '') +
      '<span class="hodms__acc-priceline"><span class="hodms__acc-price">' + money(a.p) + '</span>' +
      (a.c > a.p ? '<span class="hodms__acc-was">' + money(a.c) + '</span>' : '') +
      '<button type="button"' + qv.replace('class="', 'class="hodms__acc-view ') + '>View details</button></span>' +
      (q > 1 ? '<span class="hodms__acc-note hodms__acc-qtytotal">&times; ' + q + ' = <b>' + money(a.p * q) + '</b></span>' : '') +
      (ctl || '') +
      '</span></div>';
  }
  function renderAcc(t) {
    var host = root.querySelector('[data-ms-accrows]');
    var R = t.R;
    var sizeK = R.mode === 'sys1' ? (R.sys ? S.zones[0].btu : 0) : (R.cond ? R.cond.cap : 0);
    var mountSku = sizeK ? (sizeK <= 18 ? 'MB176' : sizeK <= 36 ? 'MB440A' : null) : null;
    var mount = mountSku ? accBySku(mountSku) : null;
    var pad = accBySku('EP04');
    /* a selected wall kit that no longer fits the matched condenser migrates */
    ACC_MOUNT_SKUS.forEach(function (sk) {
      var a = accBySku(sk);
      if (a && S.acc[a.vid] && sk !== mountSku) {
        delete S.acc[a.vid];
        if (mount && !(pad && S.acc[pad.vid])) S.acc[mount.vid] = 1;
      }
    });
    var used = {};
    var html = '';
    if (mount) { html += accRowHtml(mount); used[mount.vid] = 1; }
    if (pad) {
      html += accRowHtml(pad, (mount ? 'Alternative to the wall kit — ' : '') + (ACC_NOTES['EP04'] || ''));
      used[pad.vid] = 1;
    }
    /* LineGuard: one row, color choice + quantity */
    var lgRows = ACC_LG_COLORS.map(function (c) { return accBySku(c[0]); }).filter(Boolean);
    if (lgRows.length) {
      var lgCur = lgRows.filter(function (a) { return (S.acc[a.vid] || 0) > 0; })[0]
        || lgRows.filter(function (a) { return String(a.vid) === String(S.lgPick || ''); })[0]
        || lgRows.filter(function (a) { return a.av !== false; })[0] || lgRows[0];
      var lgQ = S.acc[lgCur.vid] || 0;
      var ctl = '<span class="hodms__acc-ctl">' +
        ACC_LG_COLORS.map(function (c) {
          var p = accBySku(c[0]);
          if (!p) return '';
          var dim = p.av === false;
          return '<button type="button" class="hodms__acc-colorchip' + (String(p.vid) === String(lgCur.vid) ? ' is-on' : '') + (dim ? ' is-dim' : '') + '" data-ms-lgcolor="' + esc(p.vid) + '"' + (dim ? ' title="Out of stock"' : '') + '>' + c[1] + '</button>';
        }).join('') +
        (lgQ > 0 ? '<span class="hodms__acc-qty"><button type="button" data-ms-accqty="' + esc(lgCur.vid) + '|-1" aria-label="Fewer">&minus;</button><b>' + lgQ + '</b><button type="button" data-ms-accqty="' + esc(lgCur.vid) + '|1" aria-label="More">+</button></span>' : '') +
        '</span>';
      html += accRowHtml(lgCur, null, ctl, true);
      lgRows.forEach(function (a) { used[a.vid] = 1; });
    }
    var riser = accBySku('H600-B');
    if (riser) { html += accRowHtml(riser); used[riser.vid] = 1; }
    /* anything else Stas adds to the collection (non-electrical) lands here */
    var elecSkus = {};
    ACC_ELEC.forEach(function (sk) { elecSkus[sk.toUpperCase()] = 1; });
    accs.forEach(function (a) {
      if (used[a.vid] || elecSkus[(a.sku || '').toUpperCase()]) return;
      if (ACC_MOUNT_SKUS.indexOf((a.sku || '').toUpperCase()) > -1) return; /* the non-matching wall kit stays hidden */
      html += accRowHtml(a); used[a.vid] = 1;
    });
    var elecAll = ACC_ELEC.map(function (sk) { return accBySku(sk); }).filter(Boolean);
    if (elecAll.length) {
      var elecShown = S.elecOpen ? elecAll : elecAll.filter(function (a, ix) { return ix === 0 || (S.acc[a.vid] || 0) > 0; });
      html += '<div class="hodms__acc-grouplbl">Electrical hookup</div>' +
        elecShown.map(function (a) { return accRowHtml(a); }).join('') +
        (elecAll.length > 1 ? '<div class="hodms__acc-elecmore"><button type="button" class="hodms__acc-elecpill" data-ms-electoggle>' + (S.elecOpen ? 'Show less' : 'Show all (' + elecAll.length + ')') + '</button></div>' : '');
    }
    host.innerHTML = html;
    root.querySelector('[data-ms-acccount]').textContent = t.accCount ? t.accCount + ' added' : 'Optional';
    root.querySelector('[data-ms-step3badge]').innerHTML = t.accCount ? CHECK : '3';
  }
  function renderWarr(t) {
    var host = root.querySelector('[data-ms-warr]');
    /* a year is offered only when its CMEQ ladder actually resolves a band
       (kitchen-builder rule: never render a plan chip that can't be carted) */
    if ((S.warr === 2 || S.warr === 5) && t.hasPrice && !warrFor(S.warr, t.discounted)) S.warr = null;
    var opts = [[0, 'No plan'], [2, '2-Year'], [5, '5-Year']];
    host.innerHTML = opts.map(function (o) {
      var y = o[0], lbl = o[1];
      if (y) {
        var pick = t.hasPrice ? warrFor(y, t.discounted) : null;
        if (t.hasPrice && !pick) return '';
        if (pick) lbl += ' &middot; ' + money(pick.price);
        return '<button type="button" class="hodms__chip' + (S.warr === y ? ' is-on' : '') + '" data-ms-warrpick="' + y + '"' + (t.hasPrice ? '' : ' disabled title="Size your zones to see plan pricing"') + '>' + lbl + '</button>';
      }
      return '<button type="button" class="hodms__chip' + (S.warr === 0 ? ' is-on' : '') + '" data-ms-warrpick="0">' + lbl + '</button>';
    }).join('');
    var b4 = root.querySelector('[data-ms-step4badge]');
    b4.innerHTML = S.warr !== null ? CHECK : '4';
    b4.classList.toggle('is-todo', S.warr === null && !!S.install);
  }
  function renderSummary(t) {
    var rows = '';
    var sysLabel = t.R.mode === 'sys1'
      ? (t.R.sys ? 'MRCOOL DIY 5th Gen system (1-zone, complete)' : seriesName() + ' system')
      : seriesName() + ' (' + S.zones.length + '-zone, auto-matched)';
    var equipCents = 0;
    t.rows.forEach(function (p) { if (!p.row.len) equipCents += p.row.p; });
    var lsCents = 0;
    t.rows.forEach(function (p) { if (p.row.len) lsCents += p.row.p; });
    rows += '<div class="hodms__sum-row"><span>' + esc(sysLabel) + '</span><b>' + (t.hasPrice ? money(equipCents) : '&mdash;') + '</b></div>';
    if (!diyOne()) rows += '<div class="hodms__sum-row"><span>Line sets (' + t.lsCount + ' of ' + S.zones.length + ')</span><b>' + (lsCents ? money(lsCents) : '&mdash;') + '</b></div>';
    if (t.accCount) rows += '<div class="hodms__sum-row"><span>Accessories (' + t.accCount + ')</span><b>' + money(t.accSum) + '</b></div>';
    if (t.wPick) rows += '<div class="hodms__sum-row"><span>' + S.warr + '-Year CPS Protection</span><b>' + money(t.warrCents) + '</b></div>';
    if (t.pct > 0 && t.hasPrice) rows += '<div class="hodms__sum-row is-save"><span>Bundle discount (' + t.pct + '%)</span><b>&minus;' + money(t.discountAmt) + '</b></div>';
    root.querySelector('[data-ms-sumrows]').innerHTML = rows;
    root.querySelector('[data-ms-total]').textContent = t.hasPrice ? money(t.total) : '$0.00';
    var aff = root.querySelector('[data-ms-affirm]');
    aff.hidden = !t.hasPrice;
    if (t.hasPrice) {
      var affP = root.querySelector('[data-ms-affirm-p]');
      var affFb = root.querySelector('[data-ms-affirm-fallback]');
      if (window.affirm && window.affirm.ui) {
        affFb.hidden = true;
        if (affP.getAttribute('data-amount') !== String(t.total)) {
          affP.setAttribute('data-amount', String(t.total));
          try { window.affirm.ui.refresh(); } catch (e) { /* non-critical */ }
        }
      } else {
        affFb.hidden = false;
        root.querySelector('[data-ms-monthly]').textContent = money(Math.round(t.total / 28.85));
      }
    }
    var ready = allDone() && t.hasPrice && !(t.capFt && t.ftTotal > t.capFt);
    var cta = root.querySelector('[data-ms-addcart]');
    cta.disabled = !ready || S.adding;
    root.querySelector('[data-ms-cartlabel]').textContent = S.adding ? 'Adding…' : 'Add Mini Split to Cart';
    var err = root.querySelector('[data-ms-builderr]');
    if (S.err) { err.hidden = false; err.innerHTML = '<span class="hodms__warnbang">!</span><span>' + esc(S.err) + '</span>'; }
    else err.hidden = true;
  }
  function artFor(rz) {
    /* filled zone slot art: the PRESET builder renders (Stas: consistent
       transparent images, not product hero photos), by install + type */
    var row = rz.hand || null;
    return {
      cls: 'hodms__slot-img hodms__slot-img--' + (rz.z.type || 'wall'),
      img: artHandler(S.install, rz.z.type) || (row && row.img ? row.img : null)
    };
  }
  function renderCanvas(t) {
    var R = t.R;
    var host = root.querySelector('[data-ms-canvas]');
    var condFilled = allBtu() && (R.mode === 'sys1' ? !!R.sys : !!R.cond);
    var condPorts = (R.cond && R.cond.multi) ? R.cond.ports : 2;
    var condImg = artCond(condPorts) || ((R.mode === 'sys1' ? R.sys : R.cond) || {}).img;
    var condChip = condFilled
      ? '<span class="hodms__slot-chip is-set">' + (R.mode === 'sys1' ? S.zones[0].btu + 'K &middot; complete system' : R.cond.cap + 'K &middot; auto-matched') + '</span>'
      : '<span class="hodms__slot-chip">Auto-matched</span>';
    var condArt = condFilled && condImg
      ? '<span class="hodms__slot-img hodms__slot-img--cond" role="img" aria-label="Condenser" style="background-image:url(&quot;' + esc(condImg) + '&quot;)"></span>'
      : PH.cond;
    var zonesHtml = S.zones.map(function (z, i) {
      var rz = R.zones[i] || { z: z, hand: null };
      var done = zoneDone(z);
      var filled = done && (R.mode === 'sys1' ? !!R.sys : !!rz.hand);
      var art;
      if (filled) {
        var a = artFor(rz);
        var img = R.mode === 'sys1' ? (artHandler('diy', z.type) || R.sys.img || null) : a.img;
        art = img
          ? '<span class="' + a.cls + '" role="img" aria-label="Air handler" style="background-image:url(&quot;' + esc(img) + '&quot;)"></span>'
          : PH[z.type] || PH.wall;
      } else art = PH[z.type] || PH.wall;
      var chip = z.btu
        ? '<span class="hodms__slot-chip is-set">' + z.btu + 'K BTU</span>'
        : '<span class="hodms__slot-chip">&mdash; BTU</span>';
      var ls = diyOne() ? '25 ft line set included' : (z.ls ? z.ls + ' ft line set' : '');
      return '<span class="hodms__zslot"><span class="hodms__zslot-branch"></span>' +
        '<span class="hodms__zslot-body"><span class="hodms__artwin hodms__artwin--z"><span class="hodms__slot-art">' + art + '</span></span>' +
        '<span class="hodms__zslot-meta"><span class="hodms__slot-label' + (done ? ' is-done' : '') + '">ZONE ' + (i + 1) + ' &middot; ' + TYPE_SHORT[z.type] + '</span>' + chip + '</span>' +
        '<span class="hodms__zslot-ls">' + ls + '</span></span></span>';
    }).join('');
    host.innerHTML =
      '<span class="hodms__cond"><span class="hodms__artwin hodms__artwin--cond"><span class="hodms__slot-art">' + condArt + '</span></span>' +
      '<span class="hodms__slot-label' + (condFilled ? ' is-done' : '') + '">CONDENSER</span>' + condChip + '</span>' +
      '<span class="hodms__trunk"></span>' +
      '<span class="hodms__zonestack"><span class="hodms__zonestack-spine"></span>' + zonesHtml + '</span>';
    syncCanvasLines(host);
    var tk = totalK();
    root.querySelector('[data-ms-capline]').textContent = tk ? 'Total capacity: ' + (tk * 1000).toLocaleString('en-US') + ' BTU' : 'Total capacity: —';
    var doneCount = S.zones.filter(zoneDone).length;
    root.querySelector('[data-ms-zonecount]').textContent = S.zones.length + ' zone' + (S.zones.length > 1 ? 's' : '') + ' · ' + doneCount + ' configured';
    var priceEl = root.querySelector('[data-ms-canvasprice]');
    if (t.hasPrice) {
      var savePct = t.listTotal > t.total ? Math.round((t.listTotal - t.total) / t.listTotal * 100) : 0;
      priceEl.innerHTML = (t.listTotal > t.total ? '<span class="hodms__canvas-list">' + money(t.listTotal) + '</span>' : '') +
        '<span class="hodms__canvas-total">' + money(t.total) + '</span>' +
        (savePct ? '<span class="hodms__savebadge">SAVE ' + savePct + '%</span>' : '');
    } else {
      priceEl.innerHTML = '<span class="hodms__canvas-hint">' + (S.install ? 'Size every zone to see your price &mdash; we&rsquo;ll match the condenser automatically' : 'Pick your install type to start &mdash; then size each room') + '</span>';
    }
    var bar = root.querySelector('[data-ms-mobilebar]');
    bar.hidden = !t.hasPrice;
    bar.classList.toggle('is-shown', t.hasPrice);
    if (t.hasPrice) {
      root.querySelector('[data-ms-mob-total]').textContent = money(t.total);
      root.querySelector('[data-ms-mob-list]').textContent = t.listTotal > t.total ? money(t.listTotal) : '';
      root.querySelector('[data-ms-mob-cartlabel]').textContent = S.adding ? 'Adding…' : 'Add Mini Split to Cart';
    }
  }

  /* connector geometry (Stas H.2 round 1 #4): art windows are locked to
     fixed heights, the condenser is centered against the zone stack, and
     the trunk + spine are measured off the rendered slots so the lines
     always meet — regardless of zone count, handler mix, or wrapping. */
  function syncCanvasLines(host) {
    var cond = host.querySelector('.hodms__cond');
    var stack = host.querySelector('.hodms__zonestack');
    var trunk = host.querySelector('.hodms__trunk');
    var spine = host.querySelector('.hodms__zonestack-spine');
    if (!cond || !stack || !trunk || !spine) return;
    var cs = getComputedStyle(root);
    var CW = parseFloat(cs.getPropertyValue('--ms-condwin')) || 170;
    var ZW = parseFloat(cs.getPropertyValue('--ms-zwin')) || 92;
    cond.style.marginTop = '0px';
    var condH = cond.offsetHeight, stackH = stack.offsetHeight;
    var mt = Math.max(0, Math.round((stackH - condH) / 2));
    cond.style.marginTop = mt + 'px';
    var condArtY = cond.offsetTop + 8 + CW / 2; /* 8 = the cond column's top padding */
    trunk.style.top = Math.round(condArtY - 1) + 'px';
    trunk.style.left = (cond.offsetLeft + cond.offsetWidth) + 'px';
    trunk.style.width = Math.max(16, stack.offsetLeft - cond.offsetLeft - cond.offsetWidth) + 'px';
    var ys = [];
    stack.querySelectorAll('.hodms__zslot').forEach(function (sl) { ys.push(sl.offsetTop + ZW / 2); });
    ys.push(condArtY - stack.offsetTop);
    var minY = Math.min.apply(null, ys), maxY = Math.max.apply(null, ys);
    spine.style.top = Math.round(minY - 1) + 'px';
    spine.style.height = Math.max(2, Math.round(maxY - minY + 2)) + 'px';
  }

  /* ---------- sizing guide modal ---------- */
  var SZ_DATA = [
    { k: 6, sq: 200, rooms: 'Small bedroom · home office · nursery' },
    { k: 9, sq: 375, rooms: 'Bedroom · kitchen · den' },
    { k: 12, sq: 500, rooms: 'Large bedroom · studio apartment' },
    { k: 18, sq: 750, rooms: 'Living room · master suite · 1-car garage' },
    { k: 24, sq: 1000, rooms: 'Open living–dining · 2-car garage' },
    { k: 36, sq: 1500, rooms: 'Open floor plan · large basement' }
  ];
  function renderSizing() {
    var modal = root.querySelector('[data-ms-modal="sizing"]');
    if (modal.hidden) return;
    root.querySelectorAll('[data-ms-sz-tab]').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-ms-sz-tab') === S.sizeTab);
      b.setAttribute('aria-selected', b.getAttribute('data-ms-sz-tab') === S.sizeTab ? 'true' : 'false');
    });
    var hand = root.querySelector('[data-ms-sz-hand]');
    var cond = root.querySelector('[data-ms-sz-cond]');
    hand.hidden = S.sizeTab !== 'hand';
    cond.hidden = S.sizeTab !== 'cond';
    if (S.sizeTab === 'hand') {
      var planW = Math.min(400, (modal.querySelector('.hodms__modal') || modal).clientWidth ? 400 : 400);
      var box = hand.querySelector('.hodms__sz-plan');
      var availW = box ? box.clientWidth : 400;
      var kpx = Math.min(9.5, ((availW || 400) - 34) / Math.sqrt(1500));
      var rects = SZ_DATA.slice().reverse().map(function (d) {
        var i = SZ_DATA.indexOf(d);
        var side = Math.round(Math.sqrt(d.sq) * kpx);
        return '<div class="hodms__sz-rect' + (S.sizeHov === i ? ' is-hov' : '') + '" data-ms-szhov="' + i + '" style="width:' + side + 'px;height:' + side + 'px">' +
          '<span class="hodms__sz-rectlbl">' + d.k + 'K · ' + d.sq.toLocaleString('en-US') + ' sq ft</span></div>';
      }).join('');
      var legend = SZ_DATA.map(function (d, i) {
        return '<div class="hodms__sz-leg' + (S.sizeHov === i ? ' is-hov' : '') + '" data-ms-szhov="' + i + '">' +
          '<span class="hodms__sz-legdot"></span><span class="hodms__sz-legbody">' +
          '<span class="hodms__sz-legtop"><span class="hodms__sz-legbtu">' + d.k + ',000 BTU</span><span class="hodms__sz-legsq">up to ' + d.sq.toLocaleString('en-US') + ' sq ft</span></span>' +
          '<span class="hodms__sz-legrooms">' + d.rooms + '</span></span></div>';
      }).join('');
      hand.innerHTML = '<p class="hodms__sz-lede">Rule of thumb: <b>20&ndash;25 BTU per square foot</b>. Rooms drawn to scale &mdash; hover a size. Round up between sizes; add ~10% for sun or tall ceilings, ~20% for poor insulation.</p>' +
        '<div class="hodms__sz-wrap"><div class="hodms__sz-plan">' + rects + '</div>' +
        '<div class="hodms__sz-legend">' + legend + '<div class="hodms__sz-callhelp">Free sizing help: <b>800-495-0144</b></div></div></div>';
      /* second pass with the real measured width so rooms fit small screens */
      var realBox = hand.querySelector('.hodms__sz-plan');
      if (realBox && realBox.clientWidth && Math.abs(realBox.clientWidth - availW) > 4) { S._szw = realBox.clientWidth; renderSizingRects(realBox); }
    } else {
      var tk = totalK();
      if (!tk) {
        cond.innerHTML = '<p class="hodms__sz-lede">Add up your air handlers &mdash; the condenser should cover roughly the total. Running a little over is normal &mdash; MRCOOL allows <b>~120&ndash;133% connected</b>, depending on the condenser.</p>' +
          '<div class="hodms__sz-empty"><b>Pick a BTU size for at least one zone</b> and your build&rsquo;s condenser math shows up here live.</div>';
        return;
      }
      var Rm = resolve();
      var capK = Rm.mode === 'sys1' ? (Rm.sys ? S.zones[0].btu : null) : (Rm.cond ? Rm.cond.cap : null);
      var overCap = false;
      if (capK === null) {
        var maxB2 = Math.max.apply(null, S.zones.map(function (z) { return z.btu || 0; }));
        var cands2 = conds.filter(function (c) { return c.install === S.install && c.multi && c.ports >= S.zones.length; })
          .sort(function (a, b) { return a.cap - b.cap; });
        for (var i = 0; i < cands2.length; i++) {
          if (tk <= cands2[i].conn && maxB2 <= cands2[i].head) { capK = cands2[i].cap; break; }
        }
        overCap = capK === null;
        if (overCap && cands2.length) capK = cands2[cands2.length - 1].cap;
        if (capK === null) capK = condLadderCaps().slice(-1)[0];
      }
      var ratio = Math.round(tk / capK * 100);
      var chips = S.zones.map(function (z, i) {
        return '<span class="hodms__sz-plus">' + (i ? '+' : '') + '</span>' +
          '<span class="hodms__sz-chip' + (z.btu ? ' is-set' : '') + '"><b>' + (z.btu ? z.btu + 'K' : '?') + '</b><span>Zone ' + (i + 1) + '</span></span>';
      }).join('');
      var left = Math.min(ratio, 139) / 139.4 * 100;
      var head, body, cls;
      if (!overCap && ratio <= 100) {
        head = '✓ ' + (tk * 1000).toLocaleString('en-US') + ' BTU of handlers on a ' + capK + ',000 BTU condenser — ' + ratio + '%.';
        body = 'Headroom: every zone gets full rated power, even with all of them running at once.'; cls = 'is-ok';
      } else if (!overCap) {
        head = (tk * 1000).toLocaleString('en-US') + ' BTU of handlers on a ' + capK + ',000 BTU condenser — ' + ratio + '% connected.';
        body = 'Normal — MRCOOL rates this condenser for over-connection. Only when every zone runs flat-out at once is output shared: about ' + Math.round(capK / tk * 100) + '% per room. Zones rarely all peak together.'; cls = 'is-shared';
      } else {
        head = (tk * 1000).toLocaleString('en-US') + ' BTU of handlers — more than one condenser supports.';
        body = 'More than one condenser supports: drop a zone to a smaller BTU size, split the rooms into two systems (add each to cart separately), or call us and we’ll spec it: 800-495-0144.'; cls = 'is-over';
      }
      cond.innerHTML = '<p class="hodms__sz-lede">Add up your air handlers &mdash; the condenser should cover roughly the total. Running a little over is normal &mdash; MRCOOL allows <b>~120&ndash;133% connected</b>, depending on the condenser.</p>' +
        '<div style="font-size:11px;font-weight:800;letter-spacing:.6px;color:#9AA0A6;margin-bottom:9px">YOUR BUILD, LIVE</div>' +
        '<div class="hodms__sz-chips">' + chips +
        '<span class="hodms__sz-plus">=</span><span class="hodms__sz-chiptotal"><b>' + tk + 'K</b><span>handlers</span></span>' +
        '<span class="hodms__sz-on">on a</span><span class="hodms__sz-chipcond"><b>' + capK + 'K</b><span>condenser</span></span></div>' +
        '<div class="hodms__sz-barwrap"><div class="hodms__sz-bar"><span class="hodms__sz-barfull">FULL POWER</span><span class="hodms__sz-barshared">SHARED AT PEAK</span><span class="hodms__sz-barover"></span></div>' +
        '<div class="hodms__sz-needle" style="left:' + left.toFixed(1) + '%"></div>' +
        '<span class="hodms__sz-bubble" style="left:' + left.toFixed(1) + '%">' + ratio + '%</span>' +
        '<span class="hodms__sz-tick" style="left:0;">0%</span>' +
        '<span class="hodms__sz-tick is-100" style="left:71.7%;">100%</span>' +
        '<span class="hodms__sz-tick is-130" style="left:93.3%;">130%</span></div>' +
        '<div class="hodms__sz-status ' + cls + '"><b>' + head + '</b><span>' + body + '</span></div>';
    }
  }
  function renderSizingRects(box) {
    var kpx = Math.min(9.5, (box.clientWidth - 34) / Math.sqrt(1500));
    box.querySelectorAll('.hodms__sz-rect').forEach(function (el) {
      var i = +el.getAttribute('data-ms-szhov');
      var side = Math.round(Math.sqrt(SZ_DATA[i].sq) * kpx);
      el.style.width = side + 'px'; el.style.height = side + 'px';
    });
  }

  /* ---------- help modal ---------- */
  var HELP = {
    install: { title: 'DIY vs. Professional Install', sub: 'How it affects equipment, price & warranty', cols: '1fr 1fr',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" fill="none" stroke="#104B6E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      tip: { b: 'Rule of thumb:', t: 'Comfortable with tools and a 3" hole saw? DIY. Already hiring an HVAC contractor? Professional equipment saves money.' },
      cards: [
        { h: 'DIY Install', bullets: true, items: ['Line sets ship pre-charged with refrigerant — Quick Connect fittings, no vacuum pump', 'A handy homeowner installs it in a weekend; warranty stays valid with self-install', 'Costs more up front, but no installer bill (typically $1,500 – $3,000+)'] },
        { h: 'Professional Install', bullets: true, items: ['Standard flare connections — requires evacuation and charging by a licensed HVAC tech', 'Lower equipment price with wall, ceiling cassette & ducted air handlers', 'Manufacturer warranty requires proof of professional installation'] }
      ] },
    type: { title: 'Air Handler Types', sub: 'Where each unit mounts and when to pick it', cols: '1fr',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24"><path d="M3.5 11 12 4l8.5 7M6 9.5V20h12V9.5" fill="none" stroke="#104B6E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      cards: [
        { h: 'Wall Mount', items: ['The most common choice — easy to install and most economical', 'Mounts at least 6 ft. above the floor and 6 in. below the ceiling', 'Sleek profile; draws air in the top, conditions out the bottom'] },
        { h: 'Ceiling Cassette', items: ['Built into the ceiling — discreet, like a ducted vent cover', 'Ideal when wall space is limited or you want it hidden', 'Center-of-room mounting mixes air in four directions'] },
        { h: 'Ducted — Professional only', items: ['Fully hidden in a ceiling or soffit; only the grilles show', 'Serves one or two adjacent rooms through short duct runs', 'Requires professional design and installation'] }
      ] },
    btu: { title: 'Air Handler BTU Rating', sub: 'Match cooling power to your room size', cols: '1fr 1fr 1fr',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24"><path d="M12 3a2 2 0 0 1 2 2v8.5a4 4 0 1 1-4 0V5a2 2 0 0 1 2-2zM12 9v6" fill="none" stroke="#104B6E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      tip: { b: 'Adjust for your room:', t: 'Add ~10% for lots of sun or ceilings over 9 ft. Add ~20% for poor insulation. Between sizes? Round up — inverters throttle down efficiently.' },
      cards: [
        { h: '6K BTU', items: ['Up to 200 sq ft'] }, { h: '9K BTU', items: ['Up to 375 sq ft'] }, { h: '12K BTU', items: ['Up to 500 sq ft'] },
        { h: '18K BTU', items: ['Up to 750 sq ft'] }, { h: '24K BTU', items: ['Up to 1,000 sq ft'] }, { h: '36K BTU', items: ['Up to 1,500 sq ft'] }
      ] },
    ls: { title: 'Line Set Length', sub: 'Measure the routed path, not point to point', cols: '1fr 1fr',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24"><path d="M3 17 17 3l4 4L7 21l-4-4zM8.5 15.5l1.7 1.7M11.5 12.5l1.7 1.7M14.5 9.5l1.7 1.7" fill="none" stroke="#104B6E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      cards: [
        { h: 'What it is', bullets: true, items: ['The refrigerant lines connecting each air handler to the condenser', 'Measure the full routed path — up walls and across joists, not point to point', 'Measure twice, purchase once — wrong lengths delay installs'] },
        { h: 'Limits', bullets: true, items: ['DIY multi-zone: up to 75 ft per zone — 172 ft total on the 3-zone condenser, 221 ft on the 4–6 zone', 'Professional (Olympus): up to 98–115 ft per zone — 197 ft total on the 3-zone, 262 ft on the 4–6 zone', 'DIY single-zone systems include a 25 ft set (75 ft max with coupler kits)', 'DIY line sets are sealed and pre-charged — never cut them; coil the slack', 'The builder checks your build against these limits automatically'] }
      ] },
    warranty: { title: 'CPS Extended Protection', sub: 'One plan covers this whole build', cols: '1fr',
      icon: '<svg width="22" height="22" viewBox="0 0 24 24"><path d="M12 3.5 19 6v5.5c0 4.5-2.9 7.6-7 9-4.1-1.4-7-4.5-7-9V6l7-2.5zM9.2 11.7l2 2 3.7-3.9" fill="none" stroke="#104B6E" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      cards: [
        { h: 'One plan, whole system', items: ['Covers the condenser and every air handler in this build', 'Parts and labor with in-home service', 'Power-surge protection included', 'No deductibles — starts after the manufacturer warranty'] }
      ] }
  };
  function openHelp(topic) {
    var d = HELP[topic];
    if (!d) return;
    var m = root.querySelector('[data-ms-modal="help"]');
    m.querySelector('[data-ms-help-icon]').innerHTML = d.icon;
    m.querySelector('[data-ms-help-title]').textContent = d.title;
    m.querySelector('[data-ms-help-sub]').textContent = d.sub;
    var cards = d.cards.map(function (c) {
      return '<div class="hodms__help-cardbox"><b>' + esc(c.h) + '</b><ul class="' + (c.bullets ? '' : 'no-bullets') + '">' +
        c.items.map(function (it) { return '<li>' + esc(it) + '</li>'; }).join('') + '</ul></div>';
    }).join('');
    m.querySelector('[data-ms-help-body]').innerHTML =
      '<div class="hodms__help-grid" style="grid-template-columns:' + d.cols + '">' + cards + '</div>' +
      (d.tip ? '<div class="hodms__help-tip"><b>' + esc(d.tip.b) + '</b> ' + esc(d.tip.t) + '</div>' : '');
    m.hidden = false;
  }

  /* ---------- cart + quote ---------- */
  function buildItems(forQuote) {
    var t = totals();
    var bundleID = Date.now();
    var pct = forQuote ? DISC_QUOTE : DISC_CART;
    var items = pickRows(t.R).map(function (p) {
      var props = { 'Bundle ID': String(bundleID) };
      if (pct > 0) props['Bundle Discount'] = pct + '%';
      if (p.room) props['Room'] = p.room;
      var st = stockFor(p.row);
      if (st.label) props['Stock'] = st.label;
      if (st.text) props['ETA'] = st.text.replace(/^Estimated (delivery|restock):\s*/i, '');
      return { id: parseInt(p.row.vid, 10), quantity: 1, properties: props };
    });
    accs.forEach(function (a) {
      var q = S.acc[a.vid] || 0;
      if (!q) return;
      var props = { 'Bundle ID': String(bundleID) };
      if (pct > 0) props['Bundle Discount'] = pct + '%';
      var st = stockFor(a);
      if (st.label) props['Stock'] = st.label;
      if (st.text) props['ETA'] = st.text.replace(/^Estimated (delivery|restock):\s*/i, '');
      items.push({ id: parseInt(a.vid, 10), quantity: q, properties: props });
    });
    var wPick = t.wPick;
    if (forQuote && wPick) wPick = warrFor(S.warr, Math.round(t.itemsSum * (100 - DISC_QUOTE) / 100)) || wPick;
    if (wPick) items.push({ id: parseInt(wPick.id, 10), quantity: 1 });
    return items;
  }
  function validateBuild(t) {
    if (!S.install) return 'Start with step 1 — choose DIY or professional install.';
    if (!allDone()) {
      var missing = S.zones.length - S.zones.filter(zoneDone).length;
      return 'Finish sizing every zone — ' + missing + ' still need' + (missing === 1 ? 's' : '') + ' a type, BTU, or line set.';
    }
    if (t.R.over) return 'This mix is more than one condenser supports — drop a zone to a smaller BTU size, split the rooms into two systems (add each to cart separately), or call 800-495-0144.';
    if (t.R.mode !== 'sys1') {
      for (var zi = 0; zi < t.R.zones.length; zi++) {
        var rz = t.R.zones[zi];
        if (rz.z.btu && !rz.hand) return 'Zone ' + (zi + 1) + '\u2019s air handler isn\u2019t available right now — pick another size or call 800-495-0144.';
        if (rz.z.ls && !rz.ls) return 'Zone ' + (zi + 1) + '\u2019s line set length isn\u2019t available right now — pick another length or call 800-495-0144.';
      }
    }
    var badAcc = accs.filter(function (a) { return S.acc[a.vid] && a.av === false; })[0];
    if (badAcc) return badAcc.t.replace(/\s*\([^)]*\)\s*$/, '') + ' is out of stock — untick it or call 800-495-0144.';
    if (!t.hasPrice) return 'We couldn’t match a system to this build — call us at 800-495-0144 and we’ll spec it.';
    if (t.capFt && t.ftTotal > t.capFt) return 'Total line set length exceeds ' + t.capFt + ' ft — shorten a run first.';
    var oos = pickRows(t.R).filter(function (p) { return p.row.av === false; });
    if (oos.length) return oos[0].row.t.replace(/\s*\([^)]*\)\s*$/, '') + ' is out of stock — call 800-495-0144 and we’ll find you the fastest option.';
    return null;
  }
  function addToCart() {
    if (S.adding) return;
    var t = totals();
    var err = validateBuild(t);
    if (err) { S.err = err; renderAll(); return; }
    S.err = null; S.adding = true; renderAll();
    var items = buildItems(false);
    var codePromise = DISC_CART > 0
      ? fetch(CUSTOM_APP + '/discounts/index.php', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) }).then(function (r) { return r.json(); }).catch(function () { return null; })
      : Promise.resolve(null);
    codePromise.then(function (code) {
      if (DISC_CART > 0 && !(code && code.success)) throw new Error('discount');
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = code && code.success ? '/checkout?discount=' + code.success : '/checkout';
      });
    }).catch(function (e) {
      S.adding = false;
      S.err = e && e.message === 'discount'
        ? 'We couldn\u2019t apply your bundle discount just now — please try again in a moment.'
        : 'Something went wrong adding your system to the cart. Please try again.';
      renderAll();
    });
  }
  function openQuote() {
    var t = totals();
    var err = validateBuild(t);
    if (err) { S.err = err; renderAll(); return; }
    S.err = null; renderAll();
    var m = root.querySelector('[data-ms-modal="quote"]');
    root.querySelector('[data-ms-quote-form]').hidden = false;
    root.querySelector('[data-ms-quote-sent]').hidden = true;
    var qitems = Math.round(t.itemsSum * (100 - DISC_QUOTE) / 100);
    var qdisc = t.discounted - qitems;
    var qw = t.wPick ? (warrFor(S.warr, qitems) || t.wPick) : null;
    var qtotal = qitems + (qw ? qw.price : 0);
    var line = S.zones.length + '-zone ' + (S.install === 'diy' ? 'DIY' : 'professional-install') + ' mini split build — ' + seriesName() +
      (t.accCount ? ' + ' + t.accCount + ' accessor' + (t.accCount === 1 ? 'y' : 'ies') : '') + (t.wPick ? ' + CPS protection plan' : '');
    root.querySelector('[data-ms-quote-summary]').textContent = line;
    var btrow = root.querySelector('[data-ms-quote-btrow]');
    btrow.hidden = !(qdisc > 0.5);
    root.querySelector('[data-ms-quote-buildtotal]').textContent = money(t.total);
    var discrow = root.querySelector('[data-ms-quote-discrow]');
    discrow.hidden = !(qdisc > 0.5);
    root.querySelector('[data-ms-quote-disc]').textContent = '−' + money(qdisc);
    root.querySelector('[data-ms-quote-total]').textContent = money(qtotal);
    m.hidden = false;
  }
  function sendQuote() {
    var emailEl = root.querySelector('[data-ms-quote-email]');
    var email = (emailEl.value || '').trim();
    if (!/@/.test(email)) return;
    var send = root.querySelector('[data-ms-quote-send]');
    send.disabled = true; send.textContent = 'Sending…';
    fetch(CUSTOM_APP + '/quote.php', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: buildItems(true), email: email, name: (root.querySelector('[data-ms-quote-name]').value || '').trim() })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (!res || res.success === false) throw new Error('quote failed');
      root.querySelector('[data-ms-quote-form]').hidden = true;
      root.querySelector('[data-ms-quote-sent]').hidden = false;
      root.querySelector('[data-ms-quote-sentto]').textContent = email;
      var t = totals();
      var q2 = Math.round(t.itemsSum * (100 - DISC_QUOTE) / 100);
      var qw2 = t.wPick ? (warrFor(S.warr, q2) || t.wPick) : null;
      root.querySelector('[data-ms-quote-total2]').textContent = money(q2 + (qw2 ? qw2.price : 0));
      send.disabled = false; send.textContent = 'Send My Quote →';
    }).catch(function () {
      send.disabled = false; send.textContent = 'Send My Quote →';
      alert('Something went wrong sending your quote. Please try again.');
    });
  }

  /* ---------- mobile canvas placement (G.3 rule: after the selector, before
     the money cards). ≤980 the canvas column moves directly after the
     auto-matched condenser band; desktop restores it as the left column. */
  var mq = window.matchMedia('(max-width: 980px)');
  function placeCanvas() {
    var canvas = root.querySelector('.hodms__canvascol');
    var grid = root.querySelector('.hodms__grid');
    var band = root.querySelector('[data-ms-band]');
    if (!canvas || !grid || !band) return;
    if (mq.matches) {
      if (canvas.previousElementSibling !== band) band.after(canvas);
    } else if (canvas.parentElement !== grid) {
      grid.insertBefore(canvas, grid.firstElementChild);
    }
  }

  /* ---------- state transitions ---------- */
  function setInstall(v) {
    if (v === S.install) return;
    S.install = v;
    var lens = lsLengths(v);
    S.zones = S.zones.map(function (z) {
      var type = (v === 'diy' && z.type === 'duct') ? 'wall' : z.type;
      var btu = z.btu && btuOptions(v, type, oneZone()).indexOf(z.btu) === -1 ? 0 : z.btu;
      var ls = z.ls && lens.indexOf(z.ls) === -1 ? 0 : z.ls;
      return { type: type, btu: btu, ls: ls };
    });
    S.err = null;
    renderAll();
  }
  function renderAll() {
    var t = totals();
    renderInstall();
    renderZones(t);
    renderBand(t);
    renderAcc(t);
    renderWarr(t);
    renderSummary(t);
    renderCanvas(t);
    renderSizing();
  }

  /* ---------- events ---------- */
  root.addEventListener('keydown', function (e) {
    /* a11y (K.3.3): Enter/Space operate the link-styled buttons + accessory rows */
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var t = e.target.closest('[data-ms-acc],[data-ms-help],[data-ms-sizing-open],.hodms__step-link');
    if (!t || t.tagName === 'BUTTON' || t.tagName === 'SELECT' || t.tagName === 'INPUT') return;
    e.preventDefault(); t.click();
  });
  root.addEventListener('click', function (e) {
    var el;
    if ((el = e.target.closest('[data-ms-install]'))) { setInstall(el.getAttribute('data-ms-install')); return; }
    if ((el = e.target.closest('[data-ms-help]'))) { openHelp(el.getAttribute('data-ms-help')); return; }
    if ((el = e.target.closest('[data-ms-help-close]'))) { root.querySelector('[data-ms-modal="help"]').hidden = true; return; }
    if ((el = e.target.closest('[data-ms-sizing-open]'))) { root.querySelector('[data-ms-modal="sizing"]').hidden = false; renderSizing(); return; }
    if ((el = e.target.closest('[data-ms-sizing-close]'))) { root.querySelector('[data-ms-modal="sizing"]').hidden = true; return; }
    if ((el = e.target.closest('[data-ms-sz-tab]'))) { S.sizeTab = el.getAttribute('data-ms-sz-tab'); renderSizing(); return; }
    if ((el = e.target.closest('[data-ms-zopen]'))) {
      S.zones[+el.getAttribute('data-ms-zopen')].open = true;
      renderAll(); return;
    }
    if ((el = e.target.closest('[data-ms-zclose]'))) {
      S.zones[+el.getAttribute('data-ms-zclose')].open = false;
      renderAll(); return;
    }
    if ((el = e.target.closest('[data-ms-ztype]'))) {
      var a = el.getAttribute('data-ms-ztype').split('|'); var i = +a[0], tp = a[1];
      var z = S.zones[i]; var was = zoneDone(z);
      z.type = tp;
      if (z.btu && btuOptions(S.install, tp, oneZone()).indexOf(z.btu) === -1) z.btu = 0;
      if (!was && zoneDone(z)) z.open = false;
      S.err = null; renderAll(); return;
    }
    if ((el = e.target.closest('[data-ms-zbtu]'))) {
      if (el.disabled) return;
      var b = el.getAttribute('data-ms-zbtu').split('|');
      var zb = S.zones[+b[0]]; var wasB = zoneDone(zb);
      zb.btu = +b[1];
      if (!wasB && zoneDone(zb)) zb.open = false;
      S.err = null; renderAll(); return;
    }
    if ((el = e.target.closest('[data-ms-zremove]'))) {
      S.zones.splice(+el.getAttribute('data-ms-zremove'), 1);
      S.zones.forEach(function (z) { if (z.btu && btuOptions(S.install, z.type, oneZone()).indexOf(z.btu) === -1) z.btu = 0; });
      S.err = null; renderAll(); return;
    }
    if ((el = e.target.closest('[data-ms-addzone]'))) {
      if (S.zones.length >= MAX_ZONES) return;
      var wasOne = oneZone();
      S.zones.push({ type: 'wall', btu: 0, ls: 0 });
      if (wasOne && S.install === 'diy') {
        /* leaving complete-system mode: the first zone re-validates as parts */
        var z0 = S.zones[0];
        if (z0.btu && btuOptions('diy', z0.type, false).indexOf(z0.btu) === -1) z0.btu = 0;
      }
      S.err = null; renderAll(); return;
    }
    if (e.target.closest('.bundle-builder--choose-view')) { return; /* HOD quick view (custom.js) handles it */ }
    if ((el = e.target.closest('[data-ms-electoggle]'))) { S.elecOpen = !S.elecOpen; renderAll(); return; }
    if ((el = e.target.closest('[data-ms-accqty]'))) {
      var aq = el.getAttribute('data-ms-accqty').split('|');
      S.acc[aq[0]] = Math.max(1, Math.min(6, (S.acc[aq[0]] || 1) + (+aq[1])));
      renderAll(); return;
    }
    if ((el = e.target.closest('[data-ms-lgcolor]'))) {
      if (el.classList.contains('is-dim')) return; /* out-of-stock color */
      var toVid = el.getAttribute('data-ms-lgcolor');
      var moveQ = 0;
      ACC_LG_COLORS.forEach(function (c) {
        var p = accBySku(c[0]);
        if (p && S.acc[p.vid]) { moveQ = S.acc[p.vid]; delete S.acc[p.vid]; }
      });
      if (moveQ > 0) S.acc[toVid] = moveQ; else S.lgPick = toVid;
      renderAll(); return;
    }
    if ((el = e.target.closest('[data-ms-acc]'))) {
      var accId = el.getAttribute('data-ms-acc');
      if (el.classList.contains('is-oos') && !S.acc[accId]) return;
      if (S.acc[accId]) { delete S.acc[accId]; }
      else {
        S.acc[accId] = 1;
        /* wall kit and ground pad are alternatives — picking one clears the other */
        var padA = accBySku('EP04');
        var isMount = ACC_MOUNT_SKUS.some(function (sk) { var a = accBySku(sk); return a && String(a.vid) === accId; });
        if (isMount && padA) delete S.acc[padA.vid];
        if (padA && accId === String(padA.vid)) ACC_MOUNT_SKUS.forEach(function (sk) { var a = accBySku(sk); if (a) delete S.acc[a.vid]; });
      }
      renderAll(); return;
    }
    if ((el = e.target.closest('[data-ms-warrpick]'))) {
      if (el.disabled) return;
      S.warr = +el.getAttribute('data-ms-warrpick');
      renderAll(); return;
    }
    if ((el = e.target.closest('[data-ms-addcart],[data-ms-mob-addcart]'))) { addToCart(); return; }
    if ((el = e.target.closest('[data-ms-openquote]'))) { openQuote(); return; }
    if ((el = e.target.closest('[data-ms-quote-close],[data-ms-quote-done]'))) { root.querySelector('[data-ms-modal="quote"]').hidden = true; return; }
    if ((el = e.target.closest('[data-ms-quote-send]'))) { sendQuote(); return; }
    if (e.target.classList && e.target.classList.contains('hodms__overlay')) { e.target.hidden = true; return; }
  });
  root.addEventListener('change', function (e) {
    var el = e.target.closest('[data-ms-zls]');
    if (!el) return;
    var zi = +el.getAttribute('data-ms-zls');
    var zl = S.zones[zi]; var wasL = zoneDone(zl);
    zl.ls = el.value ? +el.value : 0;
    if (!wasL && zoneDone(zl)) zl.open = false;
    S.err = null; renderAll();
    var fresh = root.querySelector('[data-ms-zls="' + zi + '"]');
    if (fresh) fresh.focus({ preventScroll: true });
  });
  root.addEventListener('input', function (e) {
    if (e.target.closest('[data-ms-quote-email]')) {
      root.querySelector('[data-ms-quote-send]').disabled = !/@/.test(e.target.value || '');
    }
  });
  root.addEventListener('mouseover', function (e) {
    var el = e.target.closest('[data-ms-szhov]');
    if (!el) return;
    var i = +el.getAttribute('data-ms-szhov');
    if (i === S.sizeHov) return;
    S.sizeHov = i;
    var m = root.querySelector('[data-ms-modal="sizing"]');
    if (!m.hidden) {
      m.querySelectorAll('[data-ms-szhov]').forEach(function (n) {
        n.classList.toggle('is-hov', +n.getAttribute('data-ms-szhov') === i);
      });
    }
  });

  placeCanvas();
  if (mq.addEventListener) mq.addEventListener('change', placeCanvas);
  window.addEventListener('resize', function () {
    placeCanvas();
    var cv = root.querySelector('[data-ms-canvas]');
    if (cv) syncCanvasLines(cv);
  });
  renderAll();
})();
